import { __ } from '@wordpress/i18n';

const propelInit = function() {
class FormSelect {
	constructor(element, nativeSelect) {
		this.wrapper = element;
		this.nativeSelect = nativeSelect;
		this.button = this.wrapper.querySelector('.form-select__button');

		this.optionButtons = this.wrapper.querySelectorAll(
			'.form-select__option'
		);

		this.handleGlobalEvents = this.handleGlobalEvents.bind(this);
		this.init();
	}

	init() {
		this.button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.toggle();
		});

		this.optionButtons.forEach((optionButton) => {
			optionButton.addEventListener('click', (e) => {
				this.handleOptionClick(e, optionButton);
			});
		});

		this.syncErrorState();
	}

	handleOptionClick(e, optionButton) {
		this.close();
		this.button.textContent = optionButton.textContent;

		this.optionButtons.forEach((button) => {
			if (button !== optionButton) {
				button.setAttribute('aria-selected', 'false');
			}
		});

		optionButton.setAttribute('aria-selected', 'true');
		this.nativeSelect.value = optionButton.dataset.value;
		this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
	}

	syncErrorState() {
		const hasError =
			null !== this.nativeSelect.closest('.error, .gfield_error');

		this.button.classList.toggle('error', hasError);
		this.button.setAttribute('aria-invalid', hasError ? 'true' : 'false');
	}

	toggle() {
		const isExpanded = this.button.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.button.setAttribute('aria-expanded', 'true');
		document.addEventListener('click', this.handleGlobalEvents);
		document.addEventListener('keydown', this.handleGlobalEvents);
	}

	close() {
		this.button.setAttribute('aria-expanded', 'false');
		document.removeEventListener('click', this.handleGlobalEvents);
		document.removeEventListener('keydown', this.handleGlobalEvents);
	}

	handleGlobalEvents(e) {
		if (e.type === 'keydown' && e.key === 'Escape') {
			this.close();
			this.button.focus();
		}

		if (e.type === 'click' && !this.wrapper.contains(e.target)) {
			this.close();
		}
	}
}

const addFormSelectDropdowns = (scope = null) => {
	const container = scope || document;

	const selector = scope
		? 'select:not([multiple])'
		: '.component-form select:not([multiple])';

	const selects = container.querySelectorAll(selector);

	if (0 === selects.length) {
		return;
	}

	selects.forEach((select) => {
		const wrapper = document.createElement('div');
		wrapper.classList.add('form-select');

		const button = document.createElement('button');
		button.setAttribute('type', 'button');
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-label', __('Select an option', 'propel'));
		button.classList.add('form-select__button');

		const selectedOption = select.options[select.selectedIndex];
		button.textContent = selectedOption ? selectedOption.text : '';

		const optionsContainer = document.createElement('div');
		optionsContainer.setAttribute('role', 'listbox');
		optionsContainer.classList.add('form-select__options');

		Array.from(select.options).forEach((option) => {
			const optionButton = document.createElement('button');
			optionButton.setAttribute('type', 'button');
			optionButton.setAttribute('role', 'option');

			optionButton.setAttribute(
				'aria-selected',
				option.selected ? 'true' : 'false'
			);

			optionButton.dataset.value = option.value;
			optionButton.textContent = option.text;
			optionButton.classList.add('form-select__option');
			optionsContainer.appendChild(optionButton);
		});

		select.parentNode.insertBefore(wrapper, select);
		wrapper.appendChild(button);
		wrapper.appendChild(optionsContainer);
		select.style.display = 'none';
		wrapper.appendChild(select);
		new FormSelect(wrapper, select);
	});
};

addFormSelectDropdowns();

window.addEventListener('propel-form-submit', (e) => {
	const formWrapper = e.detail.formWrapper;

	if (!formWrapper) {
		return;
	}

	addFormSelectDropdowns(formWrapper);
});

window.addEventListener('propel-hubspot-form-render', (e) => {
	const formWrapper = e.detail.formWrapper;

	if (!formWrapper) {
		return;
	}

	addFormSelectDropdowns(formWrapper);
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['form-select'] = window.propel.blocks['form-select'] || {};
window.propel.blocks['form-select'].script = propelInit;
